// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-window {
    font-family: "DM Sans", sans-serif;
    font-weight: normal;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.chat-title {
    font-size: 18px;
}

.chat-window {
    width: 400px;
    height: 550px;
    background-color: transparent;
    border: none;
    border-radius: 10px 10px 0px 0px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex !important;
    flex-direction: column;
    z-index: 10000000 !important;
    opacity: 1;
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.chat-header {
    background-color: transparent;
    color: white;
    padding: 10px;
    padding-right: 15px;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    flex-direction: column;
}

.chat-header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chat-header-title img {
    vertical-align: middle;
}

.logo-message-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.close-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    margin: 0;
    padding: 0;
    outline: none;
}

.close-chat-widget-icon {
    font-size: 20px;
}

.chat-body {
    flex: 1 1;
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: white;
}

.chat-body p {
    margin: 5px;
    width: 80%;
}

.chat-footer {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: white;
    gap: 10px;
}

.powered-by {
    display: flex;
    justify-content: center;
}

.powered-by-text {
    font-size: 10px;
    color: rgb(146, 146, 146);
    cursor: pointer;
    text-decoration: underline;
}

.input-send-container {
    display: flex;
    border-top: 1px solid #ccc;
    padding-top: 10px;
}

.chat-footer input {
    flex: 1 1;
    padding: 7px;
    border: 1px solid #ccc;
    border-radius: 8px;
    outline: none;
    font-size: 16px;
}

.chat-footer button {
    margin-left: 10px;
    padding: 5px 10px;
    padding-right: 13px;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.chat-footer button:hover {
    background-color: #0595d3;
}

.widget-icon {
    border-radius: 50%;
    height: 100px;
    width: 100px;
}

.pulsing {
    animation: pulse 2.0s infinite;
}

.preview-container-parent {
    display: flex;
    flex-direction: column;
    gap: 30px
}

@media (max-width: 768px) {
    .chat-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.65);
        z-index: 999999;
    }

    .chat-window {
        max-width: 100%;
        max-height: 450px;
    }

    body.no-scroll {
        overflow: hidden;
    }

    .preview-container-parent {
        flex-direction: column;
        gap: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/widgetPreview.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,qCAAqC;QACrC,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":[".chat-window {\r\n    font-family: \"DM Sans\", sans-serif;\r\n    font-weight: normal;\r\n}\r\n\r\n@keyframes pulse {\r\n    0% {\r\n        transform: scale(1);\r\n    }\r\n    50% {\r\n        transform: scale(1.1);\r\n    }\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.chat-title {\r\n    font-size: 18px;\r\n}\r\n\r\n.chat-window {\r\n    width: 400px;\r\n    height: 550px;\r\n    background-color: transparent;\r\n    border: none;\r\n    border-radius: 10px 10px 0px 0px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    display: flex !important;\r\n    flex-direction: column;\r\n    z-index: 10000000 !important;\r\n    opacity: 1;\r\n    transition: opacity 0.5s ease, transform 0.5s ease;\r\n}\r\n\r\n.chat-header {\r\n    background-color: transparent;\r\n    color: white;\r\n    padding: 10px;\r\n    padding-right: 15px;\r\n    border-radius: 10px 10px 0px 0px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.chat-header-title {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.chat-header-title img {\r\n    vertical-align: middle;\r\n}\r\n\r\n.logo-message-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.close-btn {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    margin: 0;\r\n    padding: 0;\r\n    outline: none;\r\n}\r\n\r\n.close-chat-widget-icon {\r\n    font-size: 20px;\r\n}\r\n\r\n.chat-body {\r\n    flex: 1;\r\n    padding: 10px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n}\r\n\r\n.chat-body p {\r\n    margin: 5px;\r\n    width: 80%;\r\n}\r\n\r\n.chat-footer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    background-color: white;\r\n    gap: 10px;\r\n}\r\n\r\n.powered-by {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.powered-by-text {\r\n    font-size: 10px;\r\n    color: rgb(146, 146, 146);\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n.input-send-container {\r\n    display: flex;\r\n    border-top: 1px solid #ccc;\r\n    padding-top: 10px;\r\n}\r\n\r\n.chat-footer input {\r\n    flex: 1;\r\n    padding: 7px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    outline: none;\r\n    font-size: 16px;\r\n}\r\n\r\n.chat-footer button {\r\n    margin-left: 10px;\r\n    padding: 5px 10px;\r\n    padding-right: 13px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n.chat-footer button:hover {\r\n    background-color: #0595d3;\r\n}\r\n\r\n.widget-icon {\r\n    border-radius: 50%;\r\n    height: 100px;\r\n    width: 100px;\r\n}\r\n\r\n.pulsing {\r\n    animation: pulse 2.0s infinite;\r\n}\r\n\r\n.preview-container-parent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 30px\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .chat-overlay {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: rgba(0, 0, 0, 0.65);\r\n        z-index: 999999;\r\n    }\r\n\r\n    .chat-window {\r\n        max-width: 100%;\r\n        max-height: 450px;\r\n    }\r\n\r\n    body.no-scroll {\r\n        overflow: hidden;\r\n    }\r\n\r\n    .preview-container-parent {\r\n        flex-direction: column;\r\n        gap: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
